import { getEnvVar } from 'utils/env';

export const ACA_REPORTING = {
    HEADER: 'Affordable Care Act (ACA) Reporting Hub',
    INFO_BOXES: [
        {
            STATUS: 'new',
            SUBHEADING: 'ACA Reporting Questionnaire',
            DESCRIPTION:
                'The ACA Reporting Questionnaire establishes the initial information required to access the ACA reporting tool.',
            BROKER_ACCESS: {
                DESCRIPTION:
                    'The ACA Reporting Questionnaire establishes the initial information required to set up and allow access to the ACA Reporting Tool.',
                NOTE_TITLE: 'NOTE:',
                NOTE_DESCRIPTION:
                    'To grant access to a Third Party, you must first complete question number one in this questionnaire.',
            },
            LINK_TEXT: 'Get Started',
            ACTION: 'consent',
        },
        {
            STATUS: 'draft',
            SUBHEADING: 'ACA Reporting Questionnaire',
            DESCRIPTION:
                'The ACA Reporting Questionnaire establishes the initial information required to access the ACA reporting tool.',
            BROKER_ACCESS: {
                DESCRIPTION:
                    'The ACA Reporting Questionnaire establishes the initial information required to set up and allow access to the ACA Reporting Tool.',
                NOTE_TITLE: 'NOTE:',
                NOTE_DESCRIPTION:
                    'To grant access to a Third Party, you must first complete question number one in this questionnaire.',
            },
            LINK_TEXT: 'Edit',
            ACTION: 'consent',
        },
        {
            STATUS: 'ready for filing',
            SUBHEADING: 'ACA Reporting Questionnaire',
            DESCRIPTION:
                'The ACA Reporting Questionnaire establishes the initial information required to access the ACA reporting tool.',
            BROKER_ACCESS: {
                DESCRIPTION:
                    'The ACA Reporting Questionnaire establishes the initial information required to set up and allow access to the ACA Reporting Tool.',
                NOTE_TITLE: 'NOTE:',
                NOTE_DESCRIPTION:
                    'To grant access to a Third Party, you must first complete question number one in this questionnaire.',
            },
            LINK_TEXT: 'View',
            ACTION: 'summary',
            UNLOCK_LINK_TEXT: 'Unlock Questionnaire',
        },
        {
            STATUS: 'ready for filing',
            SUBHEADING: 'ACA Reporting Tool',
            DESCRIPTION:
                'The ACA Reporting Tool allows the users designated from the ACA Reporting Questionnaire to access IRS Forms 1094 and 1095 and electronically transmit your filing to the IRS to complete your ACA filing requirements.',
            BROKER_ACCESS: {
                DESCRIPTION:
                    'The ACA Reporting Tool allows users to create, distribute, and electronically transmit ACA returns (Forms 1094-B/C and 1095 B/C) to the IRS (and certain states with healthcare reporting mandates) to fulfill ACA reporting requirements. ',
            },
            LINK_TEXT: 'Get Started',
            ACTION: 'HRLogics',
        },
    ],
    HR_TOOLS: 'hrTools',
    HOME: 'home',
    ACA_REPORTING_HUB: 'acaReportingHub',
    TAX_YEARS: 'taxYears',
    QUESTIONNAIRE_HEADER: 'Affordable Care Act (ACA) Reporting Questionnaire',
    QUESTIONNAIRE: {
        PREVIOUS: 'Previous',
        NEXT: 'Next',
        DONE: 'Done',
        EDIT: 'Edit',
        SUBMIT: 'Submit & Access the ACA Reporting Tool',
        HELP_TEXT:
            'To receive assistance from our HR and Compliance Experts or for technical issues, click the Get Help button below.',
    },
    COMPLETE: 'Complete',
    ANSWER_TYPES: {
        LIST: 'list',
        RADIO: 'radio',
        CHECKBOX: 'checkbox',
        TEXT: 'text',
    },
    UNLOCK_CONFIRMATION_MSG: 'Are you sure you want to unlock this questionnaire?',
    CONFIRMATION_MODAL: {
        DESCRIPTION:
            'Your questionnaire is complete and locked for filing. Next, access the ACA Reporting Tool to generate, distribute, and file your return. Please contact an administrator if you need to make changes.',
        ACTIONS: {
            OK: 'OK',
        },
    },
    CONFIRMATION_MSG: 'Your ACA Questionnaire has been submitted successfully.',
    UNLOCKED_SUCCESSFULLY_MSG: 'ACA Questionnaire unlocked successfully',
    SUMMARY_TEXT: {
        UNSAVED_SUMMARY:
            'Thank you for completing the ACA Reporting Questionnaire. To make changes, click “Edit” or click “Submit & Access the ACA Reporting Tool” to finish. Upon marking the questionnaire as Ready for Filing, you will be redirected to the ACA Reporting Hub. The next step is to access the Reporting Tool. Visit the Help Center to download the ACA Reporting B or C Series User Guide.',
        SAVED_SUMMARY:
            'Thank you for completing the ACA Reporting Questionnaire. Click “Done” to finish. Upon marking the questionnaire as ready for filing, you will be redirected to the ACA Reporting Hub. The next step is to access the Reporting Tool. Visit the Help Center to download the ACA Reporting B or C Series User Guide.',
        PARTNER_ADMIN: {
            PARTIALLY_COMPLETED:
                "The client has only partially completed the ACA Reporting Questionnaire. As a result, only the section they've completed will be visible to the broker agent. Incomplete sections will remain hidden until the client completes them.",
            FULLY_COMPLETED:
                'The ACA Reporting Questionnaire has been successfully submitted. Access the ACA Reporting Tool to begin your filing process. For guidance, visit the Help Center to download the appropriate ACA Reporting B or C Series User Guide.',
        },
    },
    TAX_YEAR: 'Tax Year',
    REVIEW_TAX_YEAR: 'Review All Tax Years',
    ALL_TAX_YEARS: 'All Tax Years',
    MARKED_READY_BY: 'Marked Ready By',
    READY_DATE: 'Ready Date',
    CHANGE_NOTIFICATION:
        'It appears that you have marked your questionnaire as ready for filing multiple times. Please allow up to 24 hours for the data to be updated based on your latest responses.',
    CONSENTED_SUCCESSFULLY_MSG:
        'An invitation, granting access to your ACA Reporting Hub, has been sent to your Third-Party Assister for the ${year} tax year.',
    REVOKED_SUCCESSFULLY_MSG:
        'Broker access has been successfully canceled. The broker no longer has access to your ACA Report',
};

export const QUESTIONNAIRE_STATUSES = {
    NEW: 'new',
    DRAFT: 'draft',
    READY_FOR_FILING: 'ready for filing',
};

export const QUESTIONNAIRE_STEPS = {
    CONSENT: 'consent',
    SUMMARY: 'summary',
};

export const QUESTIONNAIRE_MODAL = {
    HEADING: 'Consent Required',
    QUESTIONNAIRE_V1: {
        DESCRIPTION:
            'To continue with the ACA Reporting Questionnaire, you must consent to proceed. Select Exit to ACA Reporting Tool to return to the main ACA Reporting tool page.',
        SECONDARY_BUTTON_TEXT: 'Exit to ACA Reporting Tool',
        PRIMARY_BUTTON_TEXT: 'I Understand',
    },
    QUESTIONNAIRE_V2: {
        DESCRIPTION:
            'To continue with the ACA Reporting Questionnaire, you must consent to proceed. To consent, select the Previous button. To confirm your selection "I do not consent" select the Decline and Exit button.',
        SECONDARY_BUTTON_TEXT: 'Decline and Exit',
        PRIMARY_BUTTON_TEXT: 'Previous',
    },
};

export const ACA_REPORTING_TOOL = {
    HR_LOGICS: 'HRLogics',
};

export const ANSWER_LIST_INPUT = {
    HEADER_LIST: {
        BUSINESS_NAME: 'Legal Business Name',
        FEDERAL_TAX_ID: 'Federal Tax ID #',
        FEDERAL_TAX_ID_HEADING: 'Federal Tax ID Number',

        PARENT_CHILD_COMPANY: 'Parent or Child Company',
        COMPANY: {
            PARENT: 'Parent Company',
            CHILD: 'Child Company',
        },
        BUTTONS: {
            DELETE: 'Delete',
            ADD_COMPANY: 'Add Company',
        },
    },
    MAX_COUNT_LIMIT: 30,
    ERROR: 'Nine digits required',
    ONLY_SPACES: 'Sorry, only spaces are not allowed.',
    MAX_LIMIT_ERROR: 'A maximum of 30 businesses can be added.',
};

export const LIST_INPUT_ERROR_MESSAGE = {
    MAX_CHAR_LIMIT: 'Should NOT be longer than 150 characters.',
    LEADING_SPACES: 'Sorry, only spaces are not allowed',
    ALLOWED_CHAR:
        "Make sure you use only letters, numbers, spaces, and these characters: - & ' , ( )",
};

export const MANAGE_QUESTIONNAIRE = {
    TITLE: 'Manage Questionnaire',
    CAPTION: 'Choose A Company',
};

export const ACA_GRANT_BROKER_ACCESS = {
    TITLE: 'Grant Third-Party Access',
    TOOLTIP_CONTENT: 'Granting your broker access allows them to review your ACA Report.',
    BROKER_DETAILS: {
        BUSINESS_NAME: 'Business Name',
        ACCESS_STATUS: 'Access Status',
        START_DATE: 'Start Date',
        END_DATE: 'End Date',
        TAX_YEAR: 'Tax Year',
    },
    BUTTONS: {
        GRANT_ACCESS: 'Grant Access',
        REVOKE_ACCESS: 'Revoke Access',
    },
    STATUS: {
        PENDING: 'pending',
        ACCEPTED: 'accepted',
        DECLINED: 'declined',
        REVOKED: 'revoked',
    },
    REVOKE_ACCESS_TITLE: 'Revoke Broker Access',
    REVOKE_ACCESS_MSG:
        'Cancelling your broker’s access will revoke their ability to view your ACA Report. Select Revoke to proceed or Cancel to keep their access status.',
    GRANT_ACCESS_DISCLAIMER:
        '*The grant access feature is only available between January 1 and April 30.',
};

export const ACA_HELP_CENTER_URL = '/help-center/aca-reporting-hub';

export const ACA_HELP_CENTER = {
    TITLE: 'Help Center',
    LINKS: [
        {
            LINK_ID: 'helpCard_link_1',
            LINK_TEXT: `<a href='${ACA_HELP_CENTER_URL}' target='_blank'>ACA Reporting Hub User Guides and Resources</a>`,
        },
        {
            LINK_ID: 'helpCard_link_2',
            LINK_TEXT:
                "<a href='/help-center/aca-reporting-hub/quick-reference/ab273986-6c04-a6cc-0930-669501724035/details' target='_blank'>ACA Reporting Questionnaire Instruction Guide</a>",
        },
        {
            LINK_ID: 'helpCard_link_3',
            LINK_TEXT:
                "<a href='/help-center/aca-reporting-hub/videos/01607448-7c8c-028e-ffac-fdfbcb201bb2/details' target='_blank'>ACA Reporting Video Demonstration for B-Series</a>",
        },
        {
            LINK_ID: 'helpCard_link_4',
            LINK_TEXT:
                "<a href='/resources/webinars/6ymr1mosfkHsKcFQly2nAU/details' target='_blank'>ACA Reporting Video Demonstration for C-Series</a>",
        },
        {
            LINK_ID: 'helpCard_link_5',
            LINK_TEXT:
                "<a href='/help-center/aca-reporting-hub/quick-reference/ec8e8fad-0a09-d19d-62a9-a38736218e82/details' target='_blank'>ACA Granting Others Access Instruction Guide</a>",
        },
    ],
};

export const TAX_YEAR_LINKS = {
    [QUESTIONNAIRE_STATUSES.NEW]: {
        ...ACA_REPORTING.INFO_BOXES[0],
    },
    [QUESTIONNAIRE_STATUSES.DRAFT]: {
        ...ACA_REPORTING.INFO_BOXES[1],
    },
    [QUESTIONNAIRE_STATUSES.READY_FOR_FILING]: {
        ...ACA_REPORTING.INFO_BOXES[2],
    },
    SELECT: 'Select',
};

export const ROUTE_CRUMBS = {
    MANAGED_QUESTIONNAIRE: '/hr-tools/aca-reporting/managed-questionnaire',
    TAX_YEARS: '/hr-tools/aca-reporting/tax-years',
    INFO: '/hr-tools/aca-reporting/info',
    EXPERT_DRIVEN: '/hr-tools/aca-reporting/expert-driven',
    DASHBOARD: '/dashboard',
};

export const MANAGED_ACA_REPORT_ACCESS = {
    TITLE: 'Manage ACA Report Access',
    DESCRIPTION:
        'Select a company to access and manage its ACA Reporting Hub, provided that the company has granted you access.',
    LIST: {
        COLUMNS: {
            ACCESS_STATUS: 'Access Status',
            ACTIONS: 'Actions',
        },
        ACCESS_STATUS: {
            TOOLTIP_CONTENT: 'Accepting the invitation will change your status to "Active".',
        },
    },
    ACCESS_STATUS: {
        ACTIVE: 'Active',
        PENDING: 'Pending',
    },
    ACTIONS: {
        ACCEPT: 'Accept',
        DECLINE: 'Decline',
        VIEW: 'View',
    },
    SEARCH: {
        PLACEHOLDER: {
            COMPANY_NAME: 'Search by Company Name',
            USERS: 'Search Users',
        },
    },
    CONSENT_STATUS_LABEL: {
        ALL: 'All',
        ACCEPTED: 'Accepted',
        PENDING: 'Pending',
    },
    CONSENT_STATUS_VALUE: {
        ALL: 'all',
        ACCEPTED: 'accepted',
        PENDING: 'pending',
    },
    ACCEPT_MODAL: {
        TITLE: 'Accept ACA Report Invite',
        DESCRIPTION: 'Once accepted, you will have access to ${clientCompanyName} ACA Report.',
        BUTTONS: {
            ACCEPT: 'Accept',
            CANCEL: 'Cancel',
        },
    },
    DECLINE_MODAL: {
        TITLE: 'Decline ACA Report Invite',
        DESCRIPTION:
            'By declining this invitation, you are declining access to the ACA Reporting tool for all users associated with your company.',
        BUTTONS: {
            DECLINE: 'Confirm Decline',
            CANCEL: 'Cancel',
        },
        SUCCESS_MESSAGE: 'Invitation declined successfully.',
    },
};

export const FEIN_MODAL = {
    PROSPECT_PARTNER_ADMIN_TITLE: 'Action Needed',
    TITLE: 'FEIN Required',
    ACA: {
        PROSPECT_PARTNER_ADMIN_DESCRIPTION:
            'A Federal Employer Identification Number (FEIN) is required for this company before accessing the ACA Reporting Tool.<br>' +
            'Please contact your client’s administrator to add the FEIN through the company profile.',
        DESCRIPTION:
            'Please click the edit company page below to update the FEIN. Once updated, return to the ACA Reporting Hub to continue.',
    },
    PCORI: {
        PROSPECT_PARTNER_ADMIN_DESCRIPTION:
            'A Federal Employer Identification Number (FEIN) is required for this company before accessing the PCORI Reporting Tool.<br>' +
            'Please contact your client’s administrator to add the FEIN through the company profile.',
        DESCRIPTION:
            'Please click the edit company page below to update the FEIN. Once updated, return to the PCORI Reporting to continue.',
    },
    BUTTONS: {
        UPDATE: 'Update FEIN',
        CANCEL: 'Cancel',
        OK: 'OK',
    },
};

export const PROGRESS_BAR = {
    OFFSET: {
        END: 8.4,
        OTHER: 7.8,
    },
};

export const QUESTIONNAIRE_VERSIONS = {
    VERSION_ONE: 'v1',
    VERSION_TWO: 'v2',
};

export const ANSWER_CARD_INPUT = {
    PLACEHOLDER_CONTAINER: {
        FIRST_PART: "You haven't added a business yet. Click the",
        HIGHLIGHT_TEXT: '"Add Business"',
        SECOND_PART: 'button to get started.',
    },
    BUTTON_TEXT: 'Add Business',
};

export const DELETE_BUSINESS_MODAL = {
    DESCRIPTION: 'Are you sure you want to delete ${businessName}? This action cannot be undone.',
    BUTTONS: {
        DELETE: 'Delete',
        CANCEL: 'Cancel',
    },
};

export const ACA_REPORT_ACCESS_TAB = {
    MANAGE: {
        ID: 'manage',
        LABEL: 'Manage ACA Report Access',
    },
    COMPANIES: {
        ID: 'companies',
        LABEL: 'Companies',
    },
    USERS: {
        ID: 'users',
        LABEL: 'Users',
    },
    COLUMN_TITLE: {
        PARTNER_NAME: 'Partner Name',
        PARTNER: 'Partner',
    },
};

export const REDIS_VALUE = {
    ACA: 'ACA',
    PCORI: 'PCORI',
};

export const SSO_SECONDARY_ACCOUNT = {
    TOOLTIP_MESSAGE: 'You cannot perform SSO for non-primary client companies.',
};

export const EXPERT_DRIVEN_ACA_REQUIRED_SKUS = ['aca-reporting', 'askthepro'];
export const ACA_EXPERT_DRIVEN = {
    CONSENT_STATUS: {
        OPT_IN: 'opt_in',
        OPT_OUT: 'opt_out',
    },
    DEFAULT_CONTACT_METHOD: 'case_cave',
    SCHEDULER_URL: getEnvVar('ACA_EXPERT_SCHEDULER_URL') || MAESTER.thr.acaExpertSchedulerUrl,
    BANNER_STATE_KEY: 'expertDrivenBanner',
    HUB: {
        ACCESS_AND_RESOURCES: 'Access & Resources',
        SERVICE_MODELS_HEADING: 'Two service model options for ACA filing',
        SELF_SERVICE_TITLE: 'Self-Service Model',
        SELF_SERVICE_DESCRIPTION:
            'Navigate the platform and process with Experts standing by as needed.',
        EXPERT_DRIVEN_TITLE: 'Expert-Driven Service Model (optional)',
        EXPERT_DRIVEN_DESCRIPTION:
            'An Expert drives the processes and platform through interactive conversations with you.',
        STEP_TITLE: 'Step ${step}: ${year} ${title}',
        TAX_YEAR: 'Tax Year',
        HELP_CENTER_TITLE: 'Help Center Resources',
    },
    CARD: {
        NEW_BADGE: 'New!',
        TITLE: 'Expert-Driven ACA Reporting Service',
        DESCRIPTION:
            'Let Mineral Experts drive your filing. You provide important details, Experts handle the rest. Two brief interactions, kickoff (15 to 30 minutes) and year-end review (45 to 60 minutes), then we file for you.',
        NOTE_TITLE: 'NOTE:',
        NOTE_DESCRIPTION:
            'Selecting Opt-In for this option will open a new page to choose a contact method, review, and sign the agreement before an Expert is assigned to you.',
        STATUS_LABEL: 'Status:',
        STATUS_ACTIVE: 'Active',
        OPT_IN: 'Opt-in',
        REVOKE_ACCESS: 'Revoke Access',
    },
    TERMS: {
        TITLE: 'Expert-Driven Affordable Care Act (ACA) Filing',
        HOW_IT_WORKS_TITLE: 'How Expert-Driven Works',
        HOW_IT_WORKS_PARAGRAPHS: [
            'You make the key decisions during consultation, and an Expert drives the processes and platform at no additional cost.',
            'This optional service requires you to commit to a minimum of two interactions, a 15-to-30-minute kick-off call or zoom meeting, and a 45-to-60-minute year-end call or zoom meeting.',
            'These sessions ensure the correct form series is selected, determine whether any data is required from you, and your consent for form distribution and electronic filing.',
        ],
        HOW_IT_WORKS_LINK_PREFIX:
            'Additional details about the Expert-Driven service model are available in the',
        HELP_CENTER_LINK_TEXT: 'Help Center.',
        HELP_CENTER_URL: ACA_HELP_CENTER_URL,
        REVIEW_TITLE: 'Review Terms and Conditions',
        SERVICE_TITLE: 'Expert-Driven Service for tax year (${year})',
        SECTIONS: [
            {
                HEADING: '1. Scope of Expert-Driven Service & Authorization',
                PARAGRAPHS: [
                    'By opting into the Expert-Driven ACA Reporting Service (the “Services”), Client authorizes Mineral and its designated compliance experts ("Mineral Experts") to act as Client’s limited administrative agent for the sole purpose of assisting with Client\'s Affordable Care Act (ACA) reporting workflow within the Mineral ACA Reporting Hub. Authorized tasks include configuring account parameters, mapping source payroll/benefits data, populating applicable IRS tax forms (Forms 1094-C and 1095-C), managing employee statement distribution, and transmitting electronic filings to federal and state tax authorities on Client’s behalf.',
                    'Service Distinction: Client acknowledges that the Services is a specialized, managed operational feature for ACA tax reporting and is distinct from Mineral’s standard Mineral Experts™ HR helpline service. While standard Mineral Experts provide general advisory guidance under the Helpline SLA, the Expert-Driven ACA Service involves Mineral personnel directly assisting with platform configuration, form generation, distribution, and e-filing within the ACA Reporting Hub as set forth herein.',
                ],
            },
            {
                HEADING: '2. Mandatory Milestone Approvals & Client Oversight',
                PARAGRAPHS: [
                    'Client acknowledges that the Services are an assisted technology service and that Client retains ultimate legal control and ownership over all filings and employee statements. Mineral Experts will proceed through key workflow stages only upon receiving explicit authorization and approval from Client at designated approval gates (including questionnaire completion, data lock, form preview sign-off, and final e-file authorization).',
                    'Client agrees to respond to approval requests and inquiries in a timely manner. Mineral shall not be liable for any missed filing deadlines, tax penalties, or processing delays resulting from Client’s failure to provide timely sign-offs, consents, or requested information.',
                ],
            },
            {
                HEADING: '3. Client Data Responsibilities & Source Integrity',
                PARAGRAPHS: [
                    'Client is solely responsible for providing complete, accurate, and timely payroll, health coverage, COBRA, and employee census data required for ACA calculations, when requested by Mineral or to supplement a third-party carrier’s data, if applicable. Where data is provided directly to Mineral by a third-party carrier or vendor, Client remains solely responsible for verifying the completeness and accuracy of such data prior to approving any filings or form fulfillments. Mineral Experts will rely entirely on the raw data, safe harbor selections, and guidance provided by Client. Mineral does not independently audit, verify, or validate the accuracy of Client source data. Client represents and warrants that all individuals who provide instructions, data, or approvals on Client’s behalf are fully authorized representatives.',
                ],
            },
            {
                HEADING: '4. Disclaimer of Professional Advice & Tax Liability',
                PARAGRAPHS: [
                    'The Services consist of administrative and technology-managed assistance. Mineral is not a law firm, accounting firm, or certified tax advisory entity, and does not provide formal legal, tax, or accounting advice. Client remains the sole employer and plan sponsor legally responsible for compliance with Sections 6055 and 6056 of the Internal Revenue Code and applicable ACA mandates. Client remains solely liable for any IRS assessments, Employer Shared Responsibility Payments (ESRP), employer penalties, or statutory fines, except to the extent caused by Mineral’s gross negligence or willful misconduct in executing Client’s explicit, timely written instructions.',
                ],
            },
            {
                HEADING: '5. Limitation of Liability & Exclusive Remedy',
                PARAGRAPHS: [
                    '5.1 Aggregate Liability Cap: NOTWITHSTANDING ANYTHING TO THE CONTRARY IN THIS AGREEMENT, MINERAL’S TOTAL AGGREGATE LIABILITY ARISING OUT OF OR RELATED TO THE SERVICES (WHETHER IN CONTRACT, TORT, OR OTHERWISE) SHALL NOT EXCEED ONE THOUSAND US DOLLARS ($1,000.00 USD) PER TAX FILING YEAR.',
                    '5.2 Sole and Exclusive Remedy: IN THE EVENT OF AN ADMINISTRATIVE FILING ERROR, DATA PROCESSING OMISSION, OR IRS REJECTION DIRECTLY ATTRIBUTABLE TO MINERAL’S MATERIAL FAILURE TO EXECUTE CLIENT-APPROVED INSTRUCTIONS, CLIENT’S SOLE AND EXCLUSIVE REMEDY, AND MINERAL’S ENTIRE LIABILITY, SHALL BE FOR MINERAL TO USE COMMERCIALLY REASONABLE EFFORTS TO CORRECT AND RE-FILE THE AFFECTED TAX FORMS WITH THE APPLICABLE REGULATORY AUTHORITY AT NO ADDITIONAL CHARGE.',
                    '5.3 Consequential Damages Waiver: IN NO EVENT SHALL MINERAL BE LIABLE FOR ANY INDIRECT, SPECIAL, INCIDENTAL, CONSEQUENTIAL, PUNITIVE, OR COVER DAMAGES, OR FOR ANY IRS ASSESSMENTS, EMPLOYER SHARED RESPONSIBILITY PAYMENTS (ESRP), TAX PENALTIES, OR STATUTORY FINES ACCRUING TO CLIENT, REGARDLESS OF WHETHER CLIENT ACCESSES THE SERVICE DIRECTLY OR THROUGH A THIRD-PARTY BROKER, PARTNER, OR RESELLER.',
                ],
            },
            {
                HEADING: '6. Data Protection & HIPAA Disclaimer',
                PARAGRAPHS: [
                    'Client acknowledges that the ACA Reporting Hub and the Services are designed to process employment, payroll, and offer-of-coverage data (Personally Identifiable Information (“PII”)) solely for tax and regulatory compliance purposes. The Services are NOT designed or intended to process "Protected Health Information" (PHI) or "Individually Identifiable Health Information" as defined under the HIPAA Privacy Rule (45 C.F.R. § 160.103). Client agrees not to submit or share PHI in connection with the Services. Mineral maintains reasonable administrative, technical, and physical safeguards to protect all employee PII submitted by Client.',
                ],
            },
            {
                HEADING: '7. Revocation of Service & SLA Exclusions',
                PARAGRAPHS: [
                    "Client may cancel the Services at any time prior to IRS submission or form fulfillment by providing written notice to Mineral. Upon receipt of such notice, Mineral will immediately cease work on Client's ACA filings. Client acknowledges and agrees that cancellation shall not entitle Client to a refund of any fees paid. Client remains fully responsible for payment of all fees and costs incurred or accrued by Mineral prior to the effective date of cancellation.",
                    'Service-Level Exclusions: The SLA response and resolution times applicable to standard Mineral Experts™ helpline cases (e.g., helpline case resolution targets under the Service Level Agreement) do not apply to the Services herein. Timeline execution for ACA reporting is governed strictly by scheduled consultation meetings, client data submissions, IRS tax filing deadlines, and mandatory milestone approvals set forth in the ACA Reporting Hub.',
                ],
            },
        ],
        CERTIFY_LABEL:
            'By checking this box, typing my full legal name below, and selecting "Agree and Sign", I certify that I have read, understand, and agree to these Supplemental Terms and Conditions. I confirm that I am an authorized representative of Client with authority to bind the organization and grant Mineral Experts authorization to manage and submit our ACA reporting.',
        NAME_LABEL: 'Type your full name to sign',
        NAME_PLACEHOLDER: 'e.g Jamie Torres',
        NAME_HELPER:
            'Your signature is recorded with your account, timestamp, and this version of the terms.',
        NAME_MAX_LENGTH: 50,
        AGREE_AND_SIGN: 'Agree and Sign',
        REVOKE_NOTE:
            'You can revoke your opt-in of Expert-Drive service at any time and revert to self-service.',
    },
    SUCCESS_MODAL: {
        TITLE: 'You have successfully opted in to the Expert-Driven ACA reporting service!',
        SCHEDULE_TEXT: 'To schedule your kick-off call now, use the link below.',
        MY_CASES_TEXT:
            'Keep an eye on your "My Cases" within the Mineral Platform for additional information, including the option to schedule later.',
        SCHEDULE: 'Schedule',
        CLOSE: 'Close',
    },
    REVOKE_MODAL: {
        TITLE: 'Revoke Expert access?',
        DESCRIPTION:
            'Our HR experts will no longer be able to edit your ACA Reporting filing. They will still be able to view it. You can opt in to Expert Driven again at any time.',
        REVOKE_ACCESS: 'Revoke Access',
        CANCEL: 'Cancel',
        CLOSE: 'Close',
    },
    BANNERS: {
        OPTED_IN: "You've successfully signed Terms and Conditions",
        REVOKED: "You've successfully revoked access to Mineral Expert",
    },
};

export const EXPERT_DRIVEN_ACA_CONSENT_OPT_IN = 'opt_in';

export const EXPERT_DRIVEN_ACA_READ_ONLY_MSG =
    'Expert-Driven consent for this tax year is no longer active, so the questionnaire is now read-only.';
